module.exports = __webpack_public_path__ + "img/ctrl-pauli-z-root-1.6bd0339b.svg";